module.exports = __webpack_public_path__ + "static/media/single_card_deal.1393d988.mp3";